module.exports = __webpack_public_path__ + "static/media/carta_70.50f2f005.jpg";